import { useCallback } from 'react';

const useChatAPI = () => {
  //const API_BASE_URL = "http://localhost:8000/api/v1/chat";
  const API_BASE_URL = "https://wa-04-productdatadev.azurewebsites.net/api/v1/chat";

  
  const handle401Error = () => {
    console.log("401 Unauthorized - Refreshing page in 3 seconds...");
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };


  const apiCall = useCallback(async (endpoint, options = {}) => {
    const token = localStorage.getItem("msal_access_token");
    const defaultOptions = {
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    };

    if (token) {
      defaultOptions.headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...defaultOptions,
      ...options,
    });


    if (response.status === 401) {
      handle401Error();
      throw new Error(`API Error: 401 Unauthorized`);
    }
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return response;
  }, []);

  const streamMessage = useCallback(async (sessionId, messageContent, filters, onStreamData) => {
    // Clean filters
    const cleanFilters = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value.trim() !== "") {
        cleanFilters[key] = value.trim();
      }
    });

    if (filters.date_from && filters.date_to) {
      cleanFilters.date_from = filters.date_from;
      cleanFilters.date_to = filters.date_to;
    }

    // Build URL
    const filterParams = new URLSearchParams(cleanFilters);
    const streamUrl = `${API_BASE_URL}/stream/${sessionId}?query=${encodeURIComponent(
      messageContent
    )}&${filterParams.toString()}`;

    const token = localStorage.getItem("msal_access_token");
    const headers = {
      Accept: "text/event-stream",
      "Cache-Control": "no-cache",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(streamUrl, {
      method: "GET",
      headers: headers,
    });


     if (response.status === 401) {
      handle401Error();
      throw new Error(`API Error: 401 Unauthorized`);
    }
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          try {
            const data = JSON.parse(line.slice(6));
            onStreamData(data);
            
            if (data.type === "final" || data.type === "end") {
              return;
            }
          } catch (parseError) {
            console.error("Error parsing SSE data:", parseError);
          }
        }
      }
    }
  }, []);

  const submitFeedback = useCallback(async (sessionId, messageId, feedbackType, comment = "") => {
    try {
      const response = await apiCall(`/feedback/${sessionId}/${messageId}`, {
        method: "POST",
        body: JSON.stringify({
          message_id: messageId.toString(),
          feedback_type: feedbackType,
          comment: comment,
        }),
      });

      return await response.json();
    } catch (error) {
      console.error("Failed to submit feedback:", error);
      throw error;
    }
  }, [apiCall]);

  return {
    streamMessage,
    apiCall,
    submitFeedback
  };
};

export default useChatAPI;